export default {
  DEFAULT_API_ENDPOINT: 'https://api.topia.tv',
  STAGING_API_ENDPOINT: 'https://staging.api.topia.tv',

  API_PATH_TWITTER_AUTH: '/auth/twitter',
  API_PATH_GOOGLE_AUTH: '/auth/google_oauth2',

  CALLBACK_ERROR_NOT_FOUND: 'notfound',
  CALLBACK_ERROR_CANCELLED: 'cancelled',

  LS_KEY_ACCESS_TOKEN: 'enlil::accessToken',
  LS_KEY_API_ENDPOINT: 'enlil::apiEndpoint',
  LS_KEY_FLASH_MESSAGE: 'enlil::flashMessage',

  serverErrorCodes: {
    CANNOT_AUTHENTICATE_USER: 'ERR_AUTH_000',
    INVALID_CONTRACT: 'ERR_REQUEST_000',
    EXCHANGE_STEP_INSUFFICIENT: 'ERR_REQUEST_001',
    LACK_EXCHANGE_AMOUNT: 'ERR_REQUEST_002',
    TOO_MUCH_EXCHANGE_AMOUNT: 'ERR_REQUEST_003',
    DUPLICATE_REQUEST_ID: 'ERR_REQUEST_004',
    AGENCY_USER_CANNOT_REQUEST: 'ERR_REQUEST_005'
  }
}
